import React from "react";

import CardHeader from "./CardHeader";
import { ArrowIcon } from "./DashboardIcons";

export default function UniformCard({
  title,
  description,
  actionLabel,
  onClick,
  icon,
  badge,
  theme = "blue",
  preview,
}) {
  const themeMap = {
    blue: {
      icon: "bg-gradient-to-br from-blue-600 to-sky-500 text-white",
      previewBg:
        "from-blue-50 via-sky-50 to-cyan-50 dark:from-[#0F172A] dark:via-[#10213E] dark:to-[#0B162B]",
      border: "border-blue-100 dark:border-blue-500/10",
    },
    slate: {
      icon: "bg-gradient-to-br from-blue-600 to-indigo-500 text-white",
      previewBg:
        "from-blue-50 via-indigo-50 to-sky-50 dark:from-[#111827] dark:via-[#16213A] dark:to-[#0E1A2F]",
      border: "border-blue-100 dark:border-indigo-500/10",
    },
    violet: {
      icon: "bg-gradient-to-br from-violet-500 to-indigo-500 text-white",
      previewBg:
        "from-violet-50 via-indigo-50 to-fuchsia-50 dark:from-[#161327] dark:via-[#151A35] dark:to-[#131728]",
      border: "border-violet-100 dark:border-violet-500/10",
    },
    red: {
      icon: "bg-gradient-to-br from-rose-500 to-orange-400 text-white",
      previewBg:
        "from-rose-50 via-orange-50 to-red-50 dark:from-[#261317] dark:via-[#2B1916] dark:to-[#1F1114]",
      border: "border-rose-100 dark:border-rose-500/10",
    },
    amber: {
      icon: "bg-gradient-to-br from-amber-500 to-orange-400 text-white",
      previewBg:
        "from-amber-50 via-yellow-50 to-orange-50 dark:from-[#241A0D] dark:via-[#2A1F10] dark:to-[#1B140A]",
      border: "border-amber-100 dark:border-amber-500/10",
    },
    emerald: {
      icon: "bg-gradient-to-br from-emerald-500 to-teal-500 text-white",
      previewBg:
        "from-emerald-50 via-teal-50 to-cyan-50 dark:from-[#0C1F1A] dark:via-[#0D2422] dark:to-[#0A1B1F]",
      border: "border-emerald-100 dark:border-emerald-500/10",
    },
    ai: {
      icon: "bg-gradient-to-br from-cyan-500 to-teal-500 text-white",
      previewBg:
        "from-cyan-50 via-teal-50 to-sky-50 dark:from-[#0A1F26] dark:via-[#0B2422] dark:to-[#0A1C26]",
      border: "border-cyan-100 dark:border-cyan-500/15",
    },
  };

  const style = themeMap[theme] || themeMap.blue;

  return (
    <button
      type="button"
      onClick={onClick}
      className="group relative flex h-[346px] min-h-[346px] max-h-[346px] flex-col overflow-hidden rounded-[30px] border border-white/70 bg-white text-left shadow-[0_20px_48px_rgba(15,23,42,0.08)] transition-shadow duration-300 hover:shadow-[0_22px_52px_rgba(15,23,42,0.12)] dark:!border-white/10 dark:!bg-[#0f172a]"
    >
      <div className="relative flex h-full min-h-0 flex-col overflow-hidden p-4">
        <CardHeader
          icon={icon}
          title={title}
          description={description}
          badge={badge}
          iconClassName={style.icon}
        />

        <div
          className={`mt-4 min-h-0 flex-1 overflow-hidden rounded-[24px] border bg-gradient-to-br ${style.previewBg} ${style.border} p-3`}
        >
          {preview}
        </div>

        <div className="mt-4 flex shrink-0 items-center gap-2 text-[14px] font-semibold text-blue-600 dark:text-blue-300">
          <span className="truncate">{actionLabel}</span>
          <span className="shrink-0 transition-transform duration-300 group-hover:translate-x-1">
            <ArrowIcon />
          </span>
        </div>
      </div>
    </button>
  );
}